import { Skola24ScheduleImportIntervalRule, Skola24EventFilterType, Skola24EventFilterField, CoreSkola24EventNaming } from '../../../../../../models/CoreSkola24ScheduleConfigurationModels';


export const ScheduleImportIntervalRule: Skola24ScheduleImportIntervalRule[] = [
    Skola24ScheduleImportIntervalRule.UpcomingMonth,
    Skola24ScheduleImportIntervalRule.Upcoming3Months,
    Skola24ScheduleImportIntervalRule.Upcoming6Months,
    Skola24ScheduleImportIntervalRule.CurrentSemester,
];

export const ScheduleEventNaming: CoreSkola24EventNaming[] = [
    CoreSkola24EventNaming.CourseSubject,
    CoreSkola24EventNaming.Group,
    CoreSkola24EventNaming.GroupWithCourseSubject,
    CoreSkola24EventNaming.CourseSubjectWithGroup
];

export const Skola24EventFilterFieldOptions: Skola24EventFilterField[] = [
    Skola24EventFilterField.Course,
    Skola24EventFilterField.Subject,
    Skola24EventFilterField.CourseAndSubject
];

export const Skola24EventFilterTypeOptions: Skola24EventFilterType[] = [
    Skola24EventFilterType.Exact,
    Skola24EventFilterType.StartsWith,
    Skola24EventFilterType.EndsWith,
    Skola24EventFilterType.Contains
];
